// const sortCountryCodes = (a, b) => a.country > b.country ? 1 : -1;

export const countryCodes = [
    {
        "name": "Finland",
        "country": "FI",
        "continent": "Europe",
        "code": "+358",
        "lang": "FI"
    },
    {
        "name": "Sweden",
        "country": "SE",
        "continent": "Europe",
        "code": "+46",
        "lang": "SV"
    },
    {
        "name": "Germany",
        "country": "DE",
        "continent": "Europe",
        "code": "+49",
        "lang": "DE"
    },
    {
        "name": "Switzerland",
        "country": "CH",
        "continent": "Europe",
        "code": "+41",
        "lang": "DE"
    },
    {
        "name": "Norway",
        "country": "NO",
        "continent": "Europe",
        "code": "+47",
        "lang": "NO"
    },
    {
        "name": "Denmark",
        "country": "DK",
        "continent": "Europe",
        "code": "+45",
        "lang": "DA"
    },
    {
        "name": "Argentina",
        "country": "AR",
        "continent": "South America",
        "code": "+54",
        "lang": "ES"
    },
    {
        "name": "Austria",
        "country": "AT",
        "continent": "Europe",
        "code": "+43",
        "lang": "DE"
    },
    {
        "name": "Australia",
        "country": "AU",
        "continent": "Oceania",
        "code": "+61",
        "lang": "EN"
    },
    {
        "name": "Belgium",
        "country": "BE",
        "continent": "Europe",
        "code": "+32",
        "lang": "NL"
    },
    {
        "name": "Bulgaria",
        "country": "BG",
        "continent": "Europe",
        "code": "+359",
        "lang": "BG"
    },
    {
        "name": "Brazil",
        "country": "BR",
        "continent": "South America",
        "code": "+55",
        "lang": "PT"
    },
    {
        "name": "Canada",
        "country": "CA",
        "continent": "North America",
        "code": "+1",
        "lang": "EN"
    },
    {
        "name": "China",
        "country": "CN",
        "continent": "Asia",
        "code": "+86",
        "lang": "ZH"
    },
    {
        "name": "Cyprus",
        "country": "CY",
        "continent": "Europe",
        "code": "+357",
        "lang": "EL"
    },
    {
        "name": "Czech Republic",
        "country": "CZ",
        "continent": "Europe",
        "code": "+420",
        "lang": "CS"
    },
    {
        "name": "Croatia",
        "country": "HR",
        "continent": "Europe",
        "code": "+385",
        "lang": "HR"
    },
    {
        "name": "Colombia",
        "country": "CO",
        "continent": "South America",
        "code": "+57",
        "lang": "ES"
    },
    {
        "name": "Estonia",
        "country": "EE",
        "continent": "Europe",
        "code": "+372",
        "lang": "ET"
    },
    {
        "name": "Egypt",
        "country": "EG",
        "continent": "Africa",
        "code": "+20",
        "lang": "AR"
    },
    {
        "name": "France",
        "country": "FR",
        "continent": "Europe",
        "code": "+33",
        "lang": "FR"
    },
    {
        "name": "Greece",
        "country": "GR",
        "continent": "Europe",
        "code": "+30",
        "lang": "EL"
    },
    {
        "name": "Hungary",
        "country": "HU",
        "continent": "Europe",
        "code": "+36",
        "lang": "HU"
    },
    {
        "name": "Iran",
        "country": "IR",
        "continent": "Asia",
        "code": "+98",
        "lang": "FA"
    },
    {
        "name": "Indonesia",
        "country": "ID",
        "continent": "Asia",
        "code": "+62",
        "lang": "ID"
    },
    {
        "name": "India",
        "country": "IN",
        "continent": "Asia",
        "code": "+91",
        "lang": "HI"
    },
    {
        "name": "Ireland",
        "country": "IE",
        "continent": "Europe",
        "code": "+353",
        "lang": "EN"
    },
    {
        "name": "Japan",
        "country": "JP",
        "continent": "Asia",
        "code": "+81",
        "lang": "JA"
    },
    {
        "name": "South Korea",
        "country": "KR",
        "continent": "Asia",
        "code": "+82",
        "lang": "KO"
    },
    {
        "name": "Latvia",
        "country": "LV",
        "continent": "Europe",
        "code": "+371",
        "lang": "LV"
    },
    {
        "name": "Lithuania",
        "country": "LT",
        "continent": "Europe",
        "code": "+370",
        "lang": "LT"
    },
    {
        "name": "Luxembourg",
        "country": "LU",
        "continent": "Europe",
        "code": "+352",
        "lang": "FR"
    },
    {
        "name": "Malta",
        "country": "MT",
        "continent": "Europe",
        "code": "+356",
        "lang": "MT"
    },
    {
        "name": "Mexico",
        "country": "MX",
        "continent": "North America",
        "code": "+52",
        "lang": "ES"
    },
    {
        "name": "Netherlands",
        "country": "NL",
        "continent": "Europe",
        "code": "+31",
        "lang": "NL"
    },
    {
        "name": "Nigeria",
        "country": "NG",
        "continent": "Africa",
        "code": "+234",
        "lang": "EN"
    },
    {
        "name": "Pakistan",
        "country": "PK",
        "continent": "Asia",
        "code": "+92",
        "lang": "UR"
    },
    {
        "name": "Poland",
        "country": "PL",
        "continent": "Europe",
        "code": "+48",
        "lang": "PL"
    },
    {
        "name": "Portugal",
        "country": "PT",
        "continent": "Europe",
        "code": "+351",
        "lang": "PT"
    },
    {
        "name": "Romania",
        "country": "RO",
        "continent": "Europe",
        "code": "+40",
        "lang": "RO"
    },
    {
        "name": "Russia",
        "country": "RU",
        "continent": "Europe",
        "code": "+7",
        "lang": "RU"
    },
    {
        "name": "Russia",
        "country": "RU",
        "continent": "Asia",
        "code": "+7",
        "lang": "RU"
    },
    {
        "name": "Saudi Arabia",
        "country": "SA",
        "continent": "Asia",
        "code": "+966",
        "lang": "AR"
    },
    {
        "name": "South Africa",
        "country": "ZA",
        "continent": "Africa",
        "code": "+27",
        "lang": "EN"
    },
    {
        "name": "Spain",
        "country": "ES",
        "continent": "Europe",
        "code": "+34",
        "lang": "ES"
    },
    {
        "name": "Slovakia",
        "country": "SK",
        "continent": "Europe",
        "code": "+421",
        "lang": "SK"
    },
    {
        "name": "Slovenia",
        "country": "SI",
        "continent": "Europe",
        "code": "+386",
        "lang": "SL"
    },
    {
        "name": "Turkey",
        "country": "TR",
        "continent": "Asia",
        "code": "+90",
        "lang": "TR"
    },
    {
        "name": "United Kingdom",
        "country": "GB",
        "continent": "Europe",
        "code": "+44",
        "lang": "EN"
    },
    {
        "name": "United States",
        "country": "US",
        "continent": "North America",
        "code": "+1",
        "lang": "EN"
    },
]
countryCodes.sort((a, b) => countryCodes.indexOf(a.code) - countryCodes.indexOf(b.code));